import { SUPPORTED_LOCALES, type Locale } from '@alola/i18n';

/**
 * The language a person last chose, remembered in this browser (UX-003). A convenience only: storage
 * may be unavailable (private window, blocked site data) and then the deployment's starting language
 * applies — nothing else depends on it.
 */
const KEY = 'alola.locale';

export function readStoredLocale(): Locale | undefined {
  try {
    const value = window.localStorage.getItem(KEY);
    return SUPPORTED_LOCALES.find((locale) => locale === value);
  } catch {
    return undefined;
  }
}

export function storeLocale(locale: Locale): void {
  try {
    window.localStorage.setItem(KEY, locale);
  } catch {
    // Not remembered; the choice still applies to this page.
  }
}
